import { render, staticRenderFns } from "./DeviceRelieveIcon.vue?vue&type=template&id=07a3ff57&scoped=true"
import script from "./DeviceRelieveIcon.vue?vue&type=script&lang=js"
export * from "./DeviceRelieveIcon.vue?vue&type=script&lang=js"
import style0 from "./DeviceRelieveIcon.vue?vue&type=style&index=0&id=07a3ff57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a3ff57",
  null
  
)

export default component.exports